import { defineConfig } from '@chakra-ui/react'
import { recipes } from '@src/theme/next/recipes.ts'
import { semanticTokens } from '@src/theme/next/semantic-tokens.ts'
import { slotRecipes } from '@src/theme/next/slot-recipes.ts'
import { textStyles } from '@src/theme/next/text-styles.ts'
import { tokens } from '@src/theme/next/tokens.ts'

// Layered on top of the current sco config (see src/theme/index.ts), so anything not
// overridden here falls through to the production theme. See README.md for workflow.
export const nextConfig = defineConfig({
  theme: {
    tokens,
    semanticTokens,
    recipes,
    slotRecipes,
    textStyles,
  },
  globalCss: {
    // Ambient page light, fixed to the viewport: purple from the top left, a warm hint from the
    // bottom right. Translucent surfaces let it through.
    html: {
      // Also the palette for portalled overlays, which render outside the provider's Box.
      colorPalette: 'app',
      bgImage:
        'radial-gradient(60% 45% at 12% 0%, {colors.glow.primary}, transparent), radial-gradient(45% 35% at 92% 100%, {colors.glow.secondary}, transparent)',
      bgAttachment: 'fixed',
      bgRepeat: 'no-repeat',
    },
  },
})

// Root colorPalette applied by ScoChakraProvider while this design system is active.
export const nextColorPalette = {
  _dark: 'app',
  _light: 'app',
}
